export const WELCOME_PATH = '/bem-vindo';
export const DASHBOARD_HOME_PATH = '/dashboard/home';
export const DASHBOARD_V2_HOME_PATH = '/dashboard/home-v2';
export const OPERATION_HEALTH_PATH = '/dashboard/operation-health';

/**
 * Quem entra no Dashboard V2. Desde 23/09/2026 é o dashboard oficial para toda conta, e a flag
 * `dashboard_v2` não decide mais nada; a volta é reverter no código, pelo mesmo motivo de
 * `hasProductsV2` (`@/utils/productsFlow`). Continua independente de `product_multicurrency`.
 */
export const hasDashboardV2 = () => true;

export const getDashboardHomePath = (user) =>
  hasDashboardV2(user) ? DASHBOARD_V2_HOME_PATH : DASHBOARD_HOME_PATH;
export const WELCOME_MODAL_STORAGE_KEY = 'welcome_modal';
export const WELCOME_MODAL_OPEN_VALUE = '1';
export const WELCOME_MODAL_CLOSED_VALUE = '0';

export const shouldShowWelcomeModal = () =>
  typeof window !== 'undefined' &&
  localStorage.getItem(WELCOME_MODAL_STORAGE_KEY) === WELCOME_MODAL_OPEN_VALUE;

export const markWelcomeModalToShow = () => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(WELCOME_MODAL_STORAGE_KEY, WELCOME_MODAL_OPEN_VALUE);
};

export const markWelcomeModalAsSeen = () => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(WELCOME_MODAL_STORAGE_KEY, WELCOME_MODAL_CLOSED_VALUE);
};

const DASHBOARD_LAST_UPDATE_TIME_ZONE = 'America/Sao_Paulo';
const DASHBOARD_LAST_UPDATE_WITHOUT_TIMEZONE_REGEX =
  /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;
const DASHBOARD_LAST_UPDATE_WITH_TIMEZONE_REGEX = /(Z|[+-]\d{2}:?\d{2})$/i;
const dashboardLastUpdateFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: DASHBOARD_LAST_UPDATE_TIME_ZONE,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export const formatDashboardLastUpdate = (value, isFetching) => {
  if (!value) return isFetching ? 'carregando...' : 'não disponível';

  const normalizedValue = String(value).trim();
  const matchesWithoutTimeZone = normalizedValue.match(
    DASHBOARD_LAST_UPDATE_WITHOUT_TIMEZONE_REGEX
  );

  if (
    matchesWithoutTimeZone &&
    !DASHBOARD_LAST_UPDATE_WITH_TIMEZONE_REGEX.test(normalizedValue)
  ) {
    const [, year, month, day, hours, minutes] = matchesWithoutTimeZone;

    return `${day}/${month}/${year} às ${hours}:${minutes}`;
  }

  const parseableValue = normalizedValue.includes(' ')
    ? normalizedValue.replace(' ', 'T')
    : normalizedValue;
  const parsedDate = new Date(parseableValue);

  if (Number.isNaN(parsedDate.getTime())) return 'não disponível';

  return dashboardLastUpdateFormatter.format(parsedDate).replace(',', ' às');
};
